var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper_wide section_content"},[_c('div',{staticClass:"frame_wide"},[_c('AddressMap',{attrs:{"wide":true}}),_c('AccessDetail',_vm._b({},'AccessDetail',_vm.vehicle,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }